import { setContent, getContent } from "./state/content";
import Modal from "./Modal";
import Trigger from "./Trigger";
Modal.Trigger = Trigger;
Modal.setContent = setContent;
Modal.getContent = getContent;
export default Modal;
//# sourceMappingURL=index.js.map